import request from '@/api/axios'
import { apiList as api } from './apiList'

export function getNewsDetail(id) {
  return request({
    url: api.activityNews.getNewsDetail + id, // 获取资讯详情
    method: 'get',
  })
}
